import urlResolver from 'admin/utils/URLResolver';
import Cookies from 'js-cookie';
import Request from 'core/api/Request';
import { uploadAsset } from '../fileUpload';

export const request = async (...args) => {
  const res = await global.fetch(...args);
  const responseJson = await res.json();

  if (!res.ok) {
    const error = new Error('An error occurred while fetching the data.');
    // For some errors, like 413 HTTP error, the response is not JSON.
    error.info = responseJson || {};

    error.status = res.status;
    throw error;
  }

  return responseJson;
};

export const saveActivity = (activityId, activity) => {
  const url = activityId
    ? urlResolver.reverse('api:activities:object', { activityId })
    : urlResolver.reverse('api:activities');
  return request(url, {
    method: activityId ? 'PATCH' : 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
    body: JSON.stringify(activity),
  });
};

export const deleteActivityResponses = (activityId) => {
  const deleteUrl = urlResolver.reverse('api:delete:activities:responses', {
    activityId: activityId,
  });
  return request(deleteUrl, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
  });
};

export const getGeneratedUrlForUploadedFile = async (
  blockId,
  activityResponseId
) => {
  const url = urlResolver.reverse(
    'api:activities:generate-url-for-uploaded-file',
    { blockId, activityResponseId }
  );
  const response = await Request.get(url).end();
  if (response.ok) {
    return response.body;
  }
  throw response;
};

const ACTIVITY_UPLOAD_ASSET_KEY_PREFIX = 'media/assets/drawing-input-field/'; // TODO: confirm
// "//edrolo-au-test.s3.ap-southeast-2.amazonaws.com/media/assets/drawing-input-field/1e33074a43e3ed13b0d1293c6e82ffb4_w745tWN9-aQ.png"

export const uploadAssetToPublicMediaStorage = async (file, assetId) =>
  uploadAsset(file, ACTIVITY_UPLOAD_ASSET_KEY_PREFIX);
